/**
 * @Author: amywulan
 * @Date: 2021-07-07 12:00:00
 */
import api from '@/api';
const state = {
  // 新首页Feed流
  recId: '',
  componentList: [],
  componentListPage: [],
  filterList: [],
  addressInfo: {},
  nativePage: {},
  hasMore: true,
  page: 0,
  count: 20,

  // 请求值
  loading: false,
  // 选中的筛选条件
  changeFilterList: [],

  oid: '',
  scene: '',
  lastPoi: '',
  lastAid: '',
  // 首页搜索商品或店铺的接口
  // 返回值
  isDirtyWords: false,
  searchRsp: {},
  recommendRsp: {},
  recommendTitle: '',

  // errno错误码，根据错误码显示不同的空态状态
  errno: 0,

  // 筛选ids
  filterListIds: '',
};
const mutations = {
  setFilterListIds(state, data = []) {
    state.filterListIds = data.join()
  },
  setNativePage(state, data) {
    state.nativePage = data?.nativePage;
  },
  // 获取首页数据
  setFeedIndexV2(state, data) {
    state.recId = data?.recId;
    data?.componentList.map(item => {
      state.componentList.push(item);
    });
    state.filterList = data?.filterList;
    state.addressInfo = data?.addressInfo;
  },
  setFeedIndexV2Page(state, data) {
    data?.componentList.map(item => {
      state.componentListPage.push(item);
    });
    state.hasMore = data?.hasMore;
    if (state.hasMore) {
      // 有数据的话，page+1
      state.page++;
    }
  },
  resetShopListStatus() {
    state.page = 0;
    state.componentListPage = [];
  },
  // 获取首页搜索查询接口
  getFeedSearch(state, data) {
    state.isDirtyWords = data?.isDirtyWords;
    state.searchRsp = data?.searchRsp;
    state.recommendRsp = data?.recommendRsp;
    state.recommendTitle = data?.recommendTitle;
  },
  setChangeFilterList(state, data) {
    state.changeFilterList = data;
  },
};
const actions = {
  /**
   * @descripttion: 获取首页feed流
   * @param {type}
   * @return
   */
  //  40110 危险区
  //  40111 召回商家数为0，D圈内
  //  40112 召回商家数为0，D圈外
  //  40101 未开城页面
  //  4xxxx 未开国页面
  async feedIndexV2({ commit, state }, param) {
    if (param.payload?.type !== 'page' && param.page === 0) {
      state.componentList = [];
      state.componentListPage = [];
    }

    let payload = param.payload || {};
    delete param.payload;
    payload.type !== 'page' && (state.loading = true);
    try {
      const res = await api.feedIndexV2(param);
      state.loading = false;
      payload.type !== 'page' && commit('setFeedIndexV2', res);
      commit('setFeedIndexV2Page', res);
      state.errno = 0;
    } catch (err) {
      if (payload?.type === 'page') return
      commit('setNativePage', err?.data);
      state.errno = err.errno;
      state.loading = false;
    }
  },
  /**
   * @descripttion: 获取天降红包
   * @param {type}
   * @return
   */
  async popDialog({ commit, state }, param) {
    let res = {};
    try {
      res = await api.popDialog(param);
    } catch (e) {
      return false;
    }
    return res;
  },
  /**
   * @descripttion: 获取搜索列表
   * @param {type}
   * @return
   */
  async feedSearch({ commit, state }, param) {
    state.loading = true;
    const res = await api.feedSearch(param);
    commit('getFeedSearch', res);
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
